import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayoutLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconLayoutLeft"><Path d="M7 21H21V3H7V21Z" fill="currentColor"/><Path d="M3 21H4.5V3H3V21Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayoutLeft;
